import React, { useMemo, Suspense } from 'react';
import { string } from 'prop-types';
import { SimpleErrorBoundary } from 'components/SimpleErrorBoundary/SimpleErrorBoundary';
import { isWindowAvailable } from 'utils/browser';

export const LazyIcon = ({ name, className }) => {
  const Icon = useMemo(() => {
    if (isWindowAvailable && name) {
      const Component = React.lazy(
        () =>
          import(
            `@johnlewispartnership/wtr-ingredients/dist/foundations/icons/legacy/icons/${name}.js`
          ),
      );
      return () => (
        <SimpleErrorBoundary section={`LazyIcon ${name}`}>
          <Suspense fallback={null}>
            <Component {...{ className }} />
          </Suspense>
        </SimpleErrorBoundary>
      );
    }
    return () => null;
  }, [name, className]);

  return <Icon />;
};
LazyIcon.propTypes = {
  name: string.isRequired,
  className: string,
};
LazyIcon.defaultProps = {
  className: undefined,
};
